import React, {useEffect, useState} from 'react';

// import { useAuth } from "../../contexts/AuthContexts"

// import { db } from '../../firebase';
// import { getDoc, doc } from "firebase/firestore";
import profile from "../../assets/profile.jpg"; // provisório
import { Container, Content, RankingCard, Button, InfoCard, ButtonSwitch } from "./styles";
import ProgressBar from 'react-bootstrap/ProgressBar';
import 'bootstrap/dist/css/bootstrap.min.css';

import { FiArrowUpCircle, FiArrowDownCircle } from 'react-icons/fi';

export const Rank = ({dataArray, week}) => {

    const [ totalDays, setTotalDays ] = useState(1.0)
    const [ seeAll, setSeeAll ] = useState(false);
    // const array = [{pos: 1, name: "Pablo", nTrains: 5, nDiets: 4}, {pos: 2, name: "Carmona", nTrains: 5, nDiets: 4}];
    const options = ["Geral", "Treino", "Dieta"];
    const [ selectedOption, setSelectedOption ] = useState(0);


    const [ currentDataArray, setCurrentDataArray ] = useState(dataArray);
    const [ dataArrayTrain, setDataArrayTrain ] = useState();
    const [ dataArrayDiet, setDataArrayDiet ] = useState();

    const [ loading, setLoading ] = useState(true);

    const updateRanks = () => {
        if(!dataArray ||(dataArray.length == 0)) return;
        setLoading(true);
        let auxTrain = [...dataArray];
        let auxDiet = [...dataArray];

        auxTrain.sort((a, b) => {
            return (b.nTrains) - (a.nTrains);
        })
        auxDiet.sort((a, b) => {
            return (b.nDiets) - (a.nDiets);
        })

        setDataArrayTrain([...auxTrain]);
        setDataArrayDiet([...auxDiet]);
        setCurrentDataArray([...dataArray])
        setLoading(false);
    }

    useEffect(() => {
        const totalDays = Math.ceil((Date.now() - new Date("February, 28, 2022").getTime())/(60*60*24*1000));
        setTotalDays(week ? 7 : totalDays);
        updateRanks();
    }, [week, dataArray]);

    const handleSelection = (idx) => {
        setLoading(true);
        setSelectedOption(idx);

        if(idx == 1) setCurrentDataArray([...dataArrayTrain]);
        else if(idx == 2) setCurrentDataArray([...dataArrayDiet]);
        if(idx == 0) setCurrentDataArray([...dataArray]);

        setLoading(false);
    }
    

    return (
        <Container>
            <InfoCard>
                {options.map((option, idx) => (
                    <ButtonSwitch
                        key={idx}
                        style={{"backgroundColor": selectedOption === idx ? "#FFF" : "transparent", "boxShadow": selectedOption === idx ? "0px 0px 5px rgba(0,0,0,.2)" : "0px 0px 0px rgba(0,0,0,.2)"}}
                        onClick={() => handleSelection(idx)}
                    >{option}</ButtonSwitch>
                ))}
            </InfoCard>
            {!loading && <Content>
                {currentDataArray && currentDataArray.map((data, idx) => (
                    <RankingCard key={data.pos + "ranking-card"}>
                        {idx <= (seeAll ? 1000 : 4) && <div key={data.pos + "ranking-box"} className="ranking-box">
                            <img src={ profile } alt="dev" />
                            <div key={data.pos + "ranking-box-info"} className="ranking-box-info">
                                <span className="rank">{ idx+1 }º Lugar</span>
                                <span>{ data.name }</span>
                                {(selectedOption == 0) &&  <ProgressBar>
                                        <ProgressBar  style={{"borderRadius": "0px !important"}} variant="info" now={50*(data.nTrains/totalDays)} key={1} />
                                        <ProgressBar variant="sucess" now={50*(data.nDiets/totalDays)} key={2} />
                                </ProgressBar>}
                                {(selectedOption == 1) &&  <ProgressBar>
                                        <ProgressBar variant="sucess" now={100*(data.nTrains/totalDays)} key={1} />
                                </ProgressBar>}
                                {(selectedOption == 2) &&  <ProgressBar>
                                        <ProgressBar variant="sucess" now={100*(data.nDiets/totalDays)} key={1} />
                                </ProgressBar>}
                            </div>
                        </div>}
                    </RankingCard>
                ))}
                <Button onClick={ () =>  setSeeAll(!seeAll)}> { seeAll ? "Ver menos" : "Ver mais" } {seeAll ? <FiArrowUpCircle/> : <FiArrowDownCircle/>}</Button>
            </Content>}
        </Container>
    );
};


